var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { StoryChaptersState } from 'src/app/story/state/chapters/story.chapters.state';
import { Observable, Subject, combineLatest } from 'rxjs';
import { takeUntil, filter, map, distinctUntilChanged } from 'rxjs/operators';
export class ViewPrintComponent {
    // ---------- Lifecycle ----------
    constructor(store, changeDetectorRef) {
        this.store = store;
        this.changeDetectorRef = changeDetectorRef;
        // ---------- Properties ----------
        this.ngUnsubscribe = new Subject();
        this.visible = false;
    }
    // ---------- Host Listeners ----------
    beforePrint(event) {
        this.visible = true;
        this.changeDetectorRef.markForCheck();
    }
    afterPrint(event) {
        this.visible = false;
        this.changeDetectorRef.markForCheck();
    }
    ngOnInit() {
        this.initImageUrlListener();
    }
    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
    // ---------- Listeners ----------
    initImageUrlListener() {
        combineLatest(this.storyChapters$, this.store.select(StoryChaptersState.getRegisteredThumbnails))
            .pipe(filter(([chapters, thumbnails]) => chapters.length > 0 && thumbnails.size > 0), map(([chapters, thumbnails]) => thumbnails.get(chapters[0].id).urls.large), distinctUntilChanged(), takeUntil(this.ngUnsubscribe))
            .subscribe(imageUrl => {
            this.imageUrl = imageUrl;
            this.changeDetectorRef.markForCheck();
        });
    }
}
__decorate([
    Select(StoryChaptersState.getStoryChapters),
    __metadata("design:type", Observable)
], ViewPrintComponent.prototype, "storyChapters$", void 0);
